enum LocalStorageKey {
    Token = "token",
    UserId = "userId",
}

export default LocalStorageKey;
